import { memo } from 'react';

import { FileStatusButton, FileStatusIconErrored, FileStatusTitle } from '@air/feature-file-status/ui';
import { Close } from '@air/next-icons';

import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';

export type RestoreLibraryFailedPanelItemProps = {
  onClear: () => void;
};

export const RestoreLibraryFailedPanelItem = memo(({ onClear }: RestoreLibraryFailedPanelItemProps) => {
  return (
    <PaneItemTW
      avatar={<FileStatusIconErrored />}
      title={<FileStatusTitle>Failed to recover library!</FileStatusTitle>}
      buttons={
        <FileStatusButton label="Clear" onClick={onClear}>
          <Close className="size-4" />
        </FileStatusButton>
      }
    />
  );
});

RestoreLibraryFailedPanelItem.displayName = 'RestoreLibraryFailedPanelItem';
